module.exports = __webpack_public_path__ + "img/type-h3.11695e59.svg";